export const LastTransactionsStyle = {
	mainWrapper: {
		backgroundColor: '#f0f0f0',
		borderRadius: '8px',
		background: 'var(--default-white)',
		padding: '24px',
		marginTop: '16px',
		boxShadow: 'var(--box-shadow--1)',
		flex: 1,
	},
	heading: {fontSize: '20px', fontWeight: '700'},
	headWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingLeft: '24px',
		mb: '12px',
	},
	AllButton: {
		px: '20px',
	},
	tableContainer: {
		pl: '24px',
	},
};
